<template>
  <div>
    <generic-table
      ref="datatable"
      :title="$t('vehicles')"
      :columns="columns"
      :column_search="true"
      resource_url="/trip/vehicle/datatables"
      mode="grid"
      grid_class="is-col-min-7"
      page_length="50"
    >
      <template v-slot:buttons>
        <button class="button is-secondary is-rounded" @click="create">
          <span class="icon"><i class="fa fa-plus"></i></span>
          <span>{{ $t("add") }}</span>
        </button>
      </template>
      <template #item="item">
        <div class="card">
          <div class="card-image">
            <figure class="image is-64x64 m-auto">
              <img
                src="https://cdn-icons-png.flaticon.com/512/575/575780.png"
              />
            </figure>
          </div>
          <div class="card-content px-0 pt-0">
            <div class="media">
              <div class="media-content">
                <div class="title is-6 has-text-centered">
                  {{ item.licence_plate }}
                </div>
                <div class="subtitle is-6 has-text-centered">
                  {{ item.brand }} {{ item.model_year }}
                </div>
              </div>
            </div>
          </div>
          <footer class="card-footer">
            <div
              href="#"
              class="card-footer-item"
              :data-tooltip="$t('edit')"
              @click="edit_vehicle(item)"
            >
              <span class="icon"> <i class="fa fa-edit"></i> </span>
            </div>
            <div
              href="#"
              class="card-footer-item"
              :data-tooltip="$t('delete')"
              @click="delete_vehicle(item)"
            >
              <span class="icon has-text-danger">
                <i class="fa fa-trash"></i>
              </span>
            </div>
          </footer>
        </div>
      </template>
    </generic-table>
    <vehicle-modal ref="vehicle_modal" @success="refresh" />
  </div>
</template>

<script>
import GenericTable from "@/components/generic_table/GenericTable.vue";
import {
  generate_datatables_buttons,
  confirm_deletion_dialog,
  del,
  error_message,
  format_currency,
  format_date_time,
} from "@/utils";
import VehicleModal from "./vehicle_modal/Index.vue";

export default {
  name: "VehicleDatatable",
  components: { GenericTable, VehicleModal },
  data() {
    let v = this;
    return {
      columns: [
        // {
        //   title: v.$t("date"),
        //   searchable: false,
        //   // width: "12%",
        //   data: (row) => {
        //     // return `<pre>${JSON.stringify(row, null, 2)}</pre>`;
        //     return format_date_time(row.create_date) || "";
        //   },
        // },
        // {
        //   title: v.$t("movement type"),
        //   searchable: false,
        //   // width: "25%",
        //   data: (row) => {
        //     // return `<pre>${JSON.stringify(row, null, 2)}</pre>`;
        //     return row.movement_type.name || "";
        //   },
        // },
        // {
        //   title: v.$t("quantity"),
        //   name: "quantity",
        //   // width: "10%",
        //   data: (row) => {
        //     // return `<pre>${JSON.stringify(row, null, 2)}</pre>`;
        //     return row.quantity || "";
        //   },
        // },
        // {
        //   title: v.$t("product"),
        //   searchable: false,
        //   // width: "40%",
        //   data: (row) => {
        //     // return `<pre>${JSON.stringify(row, null, 2)}</pre>`;
        //     return row.product.name || "";
        //   },
        // },
        {
          title: v.$t("data"),
          // name: "name",
          searchable: false,
          // width: "35%",
          data: (row) => {
            // return `<pre>${JSON.stringify(row, null, 2)}</pre>`;
            return JSON.stringify(row, null, 2) || "";
          },
        },
        {
          title: v.$t("options"),
          searchable: false,
          data: (row) => {
            return generate_datatables_buttons([
              {
                args: { uuid: row.uuid },
                tooltip: v.$t("edit"),
                icon: "fa fa-edit",
                icon_class: "is-small",
                click: function (e) {
                  // console.log("edit order", e.detail.uuid);
                  v.$refs.warehouse_modal.edit_modal(e.detail.uuid);
                },
              },
              {
                args: { uuid: row.uuid },
                tooltip: v.$t("delete"),
                icon: "fa fa-trash",
                icon_class: "is-small has-text-danger",
                click: (e) => {
                  let uuid = e.detail.uuid;
                  confirm_deletion_dialog(
                    v.$t("are you sure to delete warehouse?"),
                    v,
                    () => {
                      del("/inventory/warehouse", { uuid: uuid })
                        .then(() => {
                          v.refresh();
                        })
                        .catch((error) => {
                          error_message(error);
                        });
                    }
                  );
                },
              },
            ]);
          },
        },
      ],
    };
  },
  methods: {
    format_date_time,
    format_currency,
    create() {
      let v = this;
      v.$refs.vehicle_modal.show_modal();
    },
    refresh() {
      let v = this;
      v.$refs.datatable.refresh();
    },
    edit_vehicle(item) {
      let v = this;
      v.$refs.vehicle_modal.edit_modal(item.uuid);
    },
    delete_vehicle(item) {
      let v = this;
      confirm_deletion_dialog(
        v.$t("are you sure to delete vehicle?"),
        v,
        () => {
          del("/trip/vehicle", { uuid: item.uuid })
            .then(() => {
              v.refresh();
            })
            .catch((error) => {
              error_message(error);
            });
        }
      );
    },
  },
  mounted() {
    this.refresh();
  },
};
</script>

<style></style>
